import { useMessagingSelector } from '../../../components/contexts/CanonicalMessagingContext';
export const UNKNOWN_SHARED_ONLY = Object.freeze({ known: false, enabled: false });
const selectPolicy = state => state.sharedOnly || UNKNOWN_SHARED_ONLY;
export function useSharedOnlyPolicy() {
  return useMessagingSelector(selectPolicy, Object.is, UNKNOWN_SHARED_ONLY) || UNKNOWN_SHARED_ONLY;
}
